module.exports = __webpack_public_path__ + "img/fespsp.f20a2a23.png";